import { render, staticRenderFns } from "./world-map-mpmc.vue?vue&type=template&id=6075b510&scoped=true&"
import script from "./world-map-mpmc.vue?vue&type=script&lang=js&"
export * from "./world-map-mpmc.vue?vue&type=script&lang=js&"
import style0 from "./world-map-mpmc.vue?vue&type=style&index=0&id=6075b510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6075b510",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VContainer,VFlex,VImg,VLayout,VRow,VSelect,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6075b510')) {
      api.createRecord('6075b510', component.options)
    } else {
      api.reload('6075b510', component.options)
    }
    module.hot.accept("./world-map-mpmc.vue?vue&type=template&id=6075b510&scoped=true&", function () {
      api.rerender('6075b510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/graphs/mpmc/world-map-mpmc.vue"
export default component.exports